import { css } from 'styled-components/macro';

/** For hiding content visually so that it is only 'visible' to screen reader apps. */
export const screenReaderOnly = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`;

/**
 * Creates a focus ring that is hidden on browsers that support ':focus-visible'
 * when the user is not navigating the app using their keyboard.
 *
 * The ring is drawn outside of the element's frame. If you need a focus ring
 * that is drawn inside of it then use the `innerFocusRing` mixin below.
 */
export const focusRing = css`
  :focus {
    box-shadow: var(--focus-ring);
    outline: none;
  }

  :focus:not(:focus-visible) {
    box-shadow: none;
  }

  :focus-visible {
    box-shadow: var(--focus-ring);
  }
`;

/**
 * Creates a focus ring that is hidden on browsers that support ':focus-visible'
 * when the user is not navigating the app using their keyboard.
 *
 * The ring is drawn inside of the element's frame. This is useful when the
 * input this mixin is applied to is positioned directly against other inputs,
 * with no margin separating them. If you were to instead use the `focusRing`
 * mixin, the ring would be hidden where it overlaps with inputs that are after
 * it in the DOM and that have a background or border.
 */
export const innerFocusRing = css`
  :focus {
    box-shadow: var(--inner-focus-ring);
    outline: none;
  }

  :focus:not(:focus-visible) {
    box-shadow: none;
  }

  :focus-visible {
    box-shadow: var(--inner-focus-ring);
  }
`;

/**
 * Set the cursor to the pointer cursor if the element this is applied to
 * is not disabled.
 */
export const pointerCursor = css`
  :not(:disabled):not([aria-disabled='true']) {
    cursor: pointer;
  }

  :disabled,
  [aria-disabled='true'] {
    cursor: auto;
  }
`;
